import type { BrowserOptions } from "@sentry/react";

/** The `awraq` Sentry project, shared by the website and the Tree Studio editor. */
export const webSentryDsn = "https://18cc4db1041246818432d4e1f2fbb2a6@o547686.ingest.sentry.io/5887404";

/** Sentry 11 broadens collection by default; both web clients keep the restrictive v10 baseline. */
export const webSentryDataCollection: BrowserOptions["dataCollection"] = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
  },
  httpBodies: [],
  urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  graphQL: { document: false, variables: false },
};
